import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ManagementPageContainer from "../../components/ManagementPageContainer/ManagementPageContainer";
import NotificationList from "../../components/NotificationList.js/NotificationList";
import { getAllNotification } from "../../http-request/notification";

const NotificationAdmin = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  useEffect(() => {
    loadNotification();
  }, []);

  const loadNotification = async () => {
    await getAllNotification().then(({ result }) => setNotifications(result));
  };

  return (
    <ManagementPageContainer title={"Notification"}>
      <Button
        type="primary"
        block
        className="ButtonFace"
        style={{
          backgroundColor: "#00BCFB",
        }}
        onClick={() => navigate("./create")}
      >
        ADD NOTIFICATION
      </Button>
      {notifications.map((_notification, key) => {
        return (
          <NotificationList
            key={key}
            {..._notification}
            loadNotification={loadNotification}
          />
        );
      })}
    </ManagementPageContainer>
  );
};

export default NotificationAdmin;
